/* file description */
import { Select } from 'antd';
import React, { FC, useEffect, useState } from 'react';
import { getAllRoleCache } from '@/common/asset-apis/assetModel';

import { RoleSelectProps } from './type';
import memo from '../memo';

export const RoleSelect: FC<RoleSelectProps> = ({
  FetchAPI,
  field,
  value,
  onChange,
  disabled,
  allowClear,
}) => {
  const [roleData, setRoleData] = useState<any[]>([]);

  useEffect(() => {
    getAllRoleCache(FetchAPI).then((res: any) => {
      const data = res?.map((item: any) => ({
        value: item.roleId?.toString(),
        label: item.roleName,
      }));
      setRoleData(data);
    });
  }, []);

  return (
    <>
      <Select
        style={{ width: '100%', minWidth: '100px' }}
        allowClear={allowClear !== false}
        showSearch
        value={value}
        options={roleData}
        disabled={disabled}
        onChange={(val) => {
          onChange?.(val);
        }}
        optionFilterProp="label"
      />
    </>
  );
};
export default memo(RoleSelect);
